<template>
    <div v-if="hasAccessDelete(FUNCTIONALITY)">
        <loader :loading="true" v-if="loading"></loader>
        <FormSectionTitle :title="'Update Forecast'"></FormSectionTitle>
        <ForecastForm
            v-if="forecast && localForecast"
            :forecast="localForecast"
            :is-update="true"
            :brand-with-campaigns="brandWithCampaigns"
            :ref-date-is-equal-to-availability-date="refDateIsEqualToAvailabilityDate"
            @update="onUpdate"
        />
        <section>
            <ClientColorButton :disabled="!isValid" @click="updateForecast">Save Forecast</ClientColorButton>
            <ClientColorButton @click="$emit('close', { updated: false })">Cancel</ClientColorButton>
        </section>
        <br />
    </div>
</template>
<script>
import { FUNCTIONALITY, RECURRENCE_TYPE, recurrenceTypeLabel } from "@/components/forecasts/constants";
import ClientColorButton from "@/components/ui/ClientColorButton";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import FormSectionTitle from "@/components/ui/Form/FormSectionTitle";
import SelectBloc from "@/components/ui/Form/SelectBloc";
import CheckboxGroupBloc from "@/components/ui/Form/CheckboxGroupBloc";
import ForecastForm from "@/components/forecasts/elements/ForecastForm";
import { mapActions } from "vuex";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import cacheService from "@/services/cache";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import historyService from "@/services/history";
import brandApplicationHasParametersService from "@/services/brandApplicationHasParameters";
import { APPLICATION, APPLICATION_PARAMETER } from "@/components/admin/brand/constant";

export default {
    components: {
        ForecastForm,
        ClientColorButton,
        TextInputBloc,
        FormSectionTitle,
        SelectBloc,
        CheckboxGroupBloc,
        loader
    },
    mixins: [TryLoad],
    props: {
        forecast: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            RECURRENCE_TYPE,
            FUNCTIONALITY,
            recurrenceTypeLabel,
            isValid: false,
            localForecast: null,
            currentBrand: null,
            currentZone: null,
            brandWithCampaigns: null,
            refDateIsEqualToAvailabilityDate: null
        };
    },
    async created() {
        this.currentZone = cacheService.getCurrentZoneId();
        this.currentBrand = cacheService.getCurrentBrandId();

        // Recup du param brand_with_campaigns
        await brandApplicationHasParametersService
            .findByBrandAndApplicationAndParameter(APPLICATION.FORECAST_ID, APPLICATION_PARAMETER.BRAND_WITH_CAMPAIGN)
            .then(res => {
                this.brandWithCampaigns = !!(res && res.value === "1");
            });

        // Recup du param ref date = availability date
        await brandApplicationHasParametersService
            .findByBrandAndApplicationAndParameter(APPLICATION.FORECAST_ID, APPLICATION_PARAMETER.REFDT_EQ_AVAILDT)
            .then(res => {
                this.refDateIsEqualToAvailabilityDate = !!(res && res.value === "1");
            });

        this.localForecast = this.forecast;
    },
    methods: {
        ...mapActions("forecast", { updateForecastInStore: "updateForecast" }),
        updateForecast() {
            if (this.currentBrand !== cacheService.getCurrentBrandId() || this.currentZone !== cacheService.getCurrentZoneId()) {
                //TODO Solution d'appoint
                let error = "Warning, a Zone or Brand conflict has been detected. This might be due to a tab opened with a different brand or Zone";
                this.$swal({
                    type: "error",
                    title: "Oops !",
                    text: error
                });
                return;
            }
            try {
                this.tryLoad(() => this.updateForecastInStore(this.localForecast))
                    .then(() => {
                        this.dialogSuccess("Forecast has been saved");
                        this.$emit("close", { updated: true });
                    })
                    .catch(() => {
                        this.$swal({
                            text: "ERROR TO UPDATE FORECAST",
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "rgb(135, 135, 135)",
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });
                    });
            } catch (e) {
                if (e.hasOwnProperty("displayMessage")) {
                    this.dialogError("An error occurred with message: " + e.displayMessage);
                } else {
                    this.dialogError("An error occurred");
                }
            }
        },
        onUpdate(data) {
            this.isValid = data.isValid;
            if (this.isValid) {
                this.localForecast = data.forecast;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// ForecastEdit.vue?c8879a0c